// extracted by mini-css-extract-plugin
export default {"options-container":"zZKsMR","optionsContainer":"zZKsMR","option":"VxB_Pu","other-protein-field":"JmdqMc","otherProteinField":"JmdqMc"};